import styles from './index.module.scss';

const el = document.createElement('div');

el.classList.add(styles.toast);

document.body.appendChild(el);

let timer: NodeJS.Timeout;

const show = (
  message: string,
  duration = 2,
  mask: boolean | (() => any) = false
) => {
  clearTimeout(timer);
  el.innerHTML = message;
  el.style.display = 'none';

  setTimeout(() => {
    el.style.display = 'block';
    timer = setTimeout(() => {
      hide();

      typeof mask === 'function' && mask();
    }, duration * 1000);
  }, 17);
};

const hide = () => {
  if (timer) {
    clearTimeout(timer);
  }

  el.classList.add(styles.hide);
  timer = setTimeout(() => {
    el.style.display = 'none';
    el.classList.remove(styles.hide);
  }, 400);
};

export default {
  show,
  success: show,
  info: show,
  warn: show,
  fail: show,
  offline: show,
  hide,
};
